// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerText{text-transform:uppercase}.alignCheckbox{display:inline-flex}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-fnol-cp-react/pages/CPBuilding/BuildingPage.scss"],"names":[],"mappings":"AAAA,YACE,wBAAA,CAEF,eACE,mBAAA","sourcesContent":[".headerText {\n  text-transform: uppercase;\n}\n.alignCheckbox {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
